export default {
  errorMessage: {
    id: 'bo_seller_file_library_modal_error_message',
    defaultMessage: 'Something went wrong while fetching your files.',
  },
  errorTitle: {
    id: 'bo_seller_file_library_modal_error_title',
    defaultMessage: 'Oops!',
  },
  id: {
    id: 'bo_seller_file_library_modal_id',
    defaultMessage: 'ID #',
  },
  loadingText: {
    id: 'bo_seller_file_library_modal_loading_text',
    defaultMessage: 'Finding your files...',
  },
  modalTitle: {
    id: 'bo_seller_file_library_modal_title',
    defaultMessage: 'File library',
  },
  noFileDescription: {
    id: 'bo_seller_file_library_modal_no_file_description',
    defaultMessage:
      'When you import or export orders via CSV files, you’ll find a record of them here.',
  },
  noFileTitle: {
    id: 'bo_seller_file_library_modal_no_file_title',
    defaultMessage: 'No files to be found.',
  },
  seeErrorReport: {
    id: 'bo_seller_file_library_modal_see_error_report',
    defaultMessage: 'See error report',
  },
  time: {
    id: 'bo_seller_file_library_modal_time',
    defaultMessage: 'Time',
  },
  type: {
    id: 'bo_seller_file_library_modal_type',
    defaultMessage: 'Type',
  },
  downloadButton: {
    id: 'bo_seller_file_library_modal_download',
    defaultMessage: 'Download',
  },
  deleteButton: {
    id: 'bo_seller_file_library_modal_delete',
    defaultMessage: 'Delete',
  },
  deleteSelectedFilesButton: {
    id: 'bo_seller_file_library_modal_delete_selected_files',
    defaultMessage: 'Delete selected files',
  },
  confirmDeleteMessage: {
    id: 'bo_seller_file_library_modal_delete_modal_confirmation_message',
    defaultMessage: `Delete {count, plural,
      one {# file}
      other {# files}
    }, are you sure?`,
  },
  yesDeleteMessage: {
    id: 'bo_seller_file_library_modal_delete_modal_delete_id_new',
    defaultMessage: `Yes, delete {count, plural,
      one {it}
      other {them}
    }`,
  },
  cancel: {
    id: 'bo_seller_file_library_modal_delete_modal_cancel',
    defaultMessage: 'Cancel',
  },
  close: {
    id: 'bo_seller_file_library_modal_close',
    defaultMessage: 'Close menu',
  },
}
